import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const CardiometabolicAppetiteControlDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const lep = getGenePalette(geneColors.LEP);
  const lepr = getGenePalette(geneColors.LEPR);
  const npy = getGenePalette(geneColors.NPY);
  const pomc = getGenePalette(geneColors.POMC);
  const mc4r = getGenePalette(geneColors.MC4R);
  const bdnf = getGenePalette(geneColors.BDNF);
  const fto = getGenePalette(geneColors.FTO);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18293_231779)">
        <rect width={1024} height={1288} transform="translate(0 142)" fill="white" />
        <g id="cardiometobolic-sodium+potassium-diagram">
          <rect width={1024} height={1288} transform="translate(0 142)" fill="white" />
          <g id="lines_2">
            <path
              id="Vector_4"
              d="M250.7 286.842H250V288.242H250.7V287.542V286.842ZM479 287.542L472 283.5V291.583L479 287.542ZM250.7 287.542V288.242L472.7 288.242V287.542V286.842L250.7 286.842V287.542Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <path
              id="Vector_5"
              d="M250.7 425.842H250V427.242H250.7V426.542V425.842ZM479 426.542L472 422.5V430.583L479 426.542ZM250.7 426.542V427.242L472.7 427.242V426.542V425.842L250.7 425.842V426.542Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="gene-LEP" {...geneGroupProps("LEP", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M303 273C303 270.791 304.791 269 307 269H399C401.209 269 403 270.791 403 273V301C403 303.209 401.209 305 399 305H307C304.791 305 303 303.209 303 301V273Z"
                fill={lep.lozengeFill}
              />
              <text
                id="gene-lozenge-label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={340.133} y={292.448}>
                  LEP
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="lep"
              groupId="gene-snps"
              genePalette={lep}
              startX={311}
              startY={307}
              snpCount={getGeneSnpCount("LEP", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-LEPR" {...geneGroupProps("LEPR", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M303 412C303 409.791 304.791 408 307 408H399C401.209 408 403 409.791 403 412V440C403 442.209 401.209 444 399 444H307C304.791 444 303 442.209 303 440V412Z"
                fill={lepr.lozengeFill}
              />
              <text
                id="gene-lozenge-label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={335.242} y={431.448}>
                  LEPR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="lepr"
              groupId="gene-snps_2"
              genePalette={lepr}
              startX={311}
              startY={446}
              snpCount={getGeneSnpCount("LEPR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NPY" {...geneGroupProps("NPY", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M817 738C817 735.791 818.791 734 821 734H913C915.209 734 917 735.791 917 738V766C917 768.209 915.209 770 913 770H821C818.791 770 817 768.209 817 766V738Z"
                fill={npy.lozengeFill}
              />
              <text
                id="gene-lozenge-label_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={852.188} y={757.448}>
                  NPY
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="npy"
              groupId="gene-snps_3"
              genePalette={npy}
              startX={825}
              startY={772}
              snpCount={getGeneSnpCount("NPY", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NPY_2" {...geneGroupProps("NPY", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M261 738C261 735.791 262.791 734 265 734H357C359.209 734 361 735.791 361 738V766C361 768.209 359.209 770 357 770H265C262.791 770 261 768.209 261 766V738Z"
                fill={npy.lozengeFill}
              />
              <text
                id="gene-lozenge-label_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={296.188} y={757.448}>
                  NPY
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="npy-2"
              groupId="gene-snps_4"
              genePalette={npy}
              startX={269}
              startY={772}
              snpCount={getGeneSnpCount("NPY", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-POMC" {...geneGroupProps("POMC", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M670 738C670 735.791 671.791 734 674 734H766C768.209 734 770 735.791 770 738V766C770 768.209 768.209 770 766 770H674C671.791 770 670 768.209 670 766V738Z"
                fill={pomc.lozengeFill}
              />
              <text
                id="gene-lozenge-label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={696.57} y={757.448}>
                  POMC
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="pomc"
              groupId="gene-snps_5"
              genePalette={pomc}
              startX={678}
              startY={772}
              snpCount={getGeneSnpCount("POMC", expectedSnps, geneColors)}
            />
          </g>
          <path id="Vector 360" d="M427 602L477 568" stroke="#1A1A1A" strokeWidth={1.4} />
          <path id="Vector 363" d="M427 645L477 611" stroke="#E44C4B" strokeWidth={1.4} />
          <path id="Vector 361" d="M596 602L546 568" stroke="#1A1A1A" strokeWidth={1.4} />
          <path id="Vector 362" d="M598 647L548 613" stroke="#E44C4B" strokeWidth={1.4} />
          <g id="gene-POMC_2" {...geneGroupProps("POMC", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M115 738C115 735.791 116.791 734 119 734H211C213.209 734 215 735.791 215 738V766C215 768.209 213.209 770 211 770H119C116.791 770 115 768.209 115 766V738Z"
                fill={pomc.lozengeFill}
              />
              <text
                id="gene-lozenge-label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={141.57} y={757.448}>
                  POMC
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="pomc-2"
              groupId="gene-snps_6"
              genePalette={pomc}
              startX={123}
              startY={772}
              snpCount={getGeneSnpCount("POMC", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MC4R" {...geneGroupProps("MC4R", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M113 1133C113 1130.79 114.791 1129 117 1129H209C211.209 1129 213 1130.79 213 1133V1161C213 1163.21 211.209 1165 209 1165H117C114.791 1165 113 1163.21 113 1161V1133Z"
                fill={mc4r.lozengeFill}
              />
              <text
                id="gene-lozenge-label_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={141.117} y={1152.45}>
                  MC4R
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mc4r"
              groupId="gene-snps_7"
              genePalette={mc4r}
              startX={121}
              startY={1167}
              snpCount={getGeneSnpCount("MC4R", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-BDNF" {...geneGroupProps("BDNF", onGeneClick)}>
            <g id="gene-lozenge_12">
              <path
                d="M290 1133C290 1130.79 291.791 1129 294 1129H386C388.209 1129 390 1130.79 390 1133V1161C390 1163.21 388.209 1165 386 1165H294C291.791 1165 290 1163.21 290 1161V1133Z"
                fill={bdnf.lozengeFill}
              />
              <text
                id="gene-lozenge-label_8"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={319.789} y={1152.45}>
                  BDNF
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="bdnf"
              groupId="gene-snps_8"
              genePalette={bdnf}
              startX={298}
              startY={1167}
              snpCount={getGeneSnpCount("BDNF", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-FTO" {...geneGroupProps("FTO", onGeneClick)}>
            <g id="gene-lozenge_13">
              <path
                d="M477 1133C477 1130.79 478.791 1129 481 1129H573C575.209 1129 577 1130.79 577 1133V1161C577 1163.21 575.209 1165 573 1165H481C478.791 1165 477 1163.21 477 1161V1133Z"
                fill={fto.lozengeFill}
              />
              <text
                id="gene-lozenge-label_9"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={512.477} y={1152.45}>
                  FTO
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="fto"
              groupId="gene-snps_9"
              genePalette={fto}
              startX={485}
              startY={1167}
              snpCount={getGeneSnpCount("FTO", expectedSnps, geneColors)}
            />
          </g>
          <text
            id="Binds receptor"
            fill="#818181"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Medium"
            fontSize={14}
            letterSpacing="0em"
          >
            <tspan x={522} y={343.767}>
              Binds receptor
            </tspan>
          </text>
          <g id="Report titles">
            <rect width={82} height={36} transform="translate(673 786)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={678.521} y={800.08}>
                (weak POMC{" "}
              </tspan>
              <tspan x={673.318} y={816.08}>
                satiety signals)
              </tspan>
            </text>
          </g>
          <g id="Report titles_2">
            <rect width={47} height={36} transform="translate(922 734)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={922.432} y={748.08}>
                {"(Hunger "}
              </tspan>
              <tspan x={922.297} y={764.08}>
                neurons)
              </tspan>
            </text>
          </g>
          <text
            id="Adipose tissue"
            fill="#1A1A1A"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Medium"
            fontSize={14}
            letterSpacing="0em"
          >
            <tspan x={148} y={289.767}>
              Adipose tissue
            </tspan>
          </text>
          <g id="Hormones_3">
            <g id="Frame 471">
              <g id="diamond_2">
                <text
                  id="label"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={493.169} y={292.767}>
                    Leptin
                  </tspan>
                </text>
                <path
                  id="Vector_6"
                  d="M512.371 311.102C512.783 310.992 513.217 310.992 513.629 311.102L540.754 318.37C542.561 318.854 544.215 317.201 543.73 315.394L536.462 288.269C536.352 287.857 536.352 287.423 536.462 287.011L543.73 259.885C544.215 258.078 542.561 256.425 540.754 256.909L513.629 264.177C513.217 264.288 512.783 264.288 512.371 264.177L485.246 256.909C483.439 256.425 481.785 258.078 482.27 259.885L489.538 287.011C489.648 287.423 489.648 287.857 489.538 288.269L482.27 315.394C481.785 317.201 483.439 318.854 485.246 318.37L512.371 311.102Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                  strokeMiterlimit={10}
                />
              </g>
            </g>
          </g>
          <g id="Hormones_4">
            <g id="Frame 471_2">
              <g id="diamond_3">
                <text
                  id="label_2"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={493.169} y={569.767}>
                    Leptin
                  </tspan>
                </text>
                <path
                  id="Vector_7"
                  d="M512.371 588.102C512.783 587.992 513.217 587.992 513.629 588.102L540.754 595.37C542.561 595.854 544.215 594.201 543.73 592.394L536.462 565.269C536.352 564.857 536.352 564.423 536.462 564.011L543.73 536.885C544.215 535.078 542.561 533.425 540.754 533.909L513.629 541.177C513.217 541.288 512.783 541.288 512.371 541.177L485.246 533.909C483.439 533.425 481.785 535.078 482.27 536.885L489.538 564.011C489.648 564.423 489.648 564.857 489.538 565.269L482.27 592.394C481.785 594.201 483.439 595.854 485.246 595.37L512.371 588.102Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                  strokeMiterlimit={10}
                />
                <path
                  id="receptor-protein_2"
                  d="M541.488 599.352L513.665 592.213C513.12 592.073 512.548 592.073 512.003 592.213L485.512 599.011C484.034 599.39 483 600.722 483 602.249L483 617.399C483 619.583 485.059 621.18 487.174 620.637L512.101 614.241C512.646 614.102 513.217 614.102 513.762 614.241L539.826 620.929C541.941 621.472 544 619.874 544 617.691V602.59C544 601.064 542.966 599.732 541.488 599.352Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                />
              </g>
            </g>
          </g>
          <g id="Hormones_5">
            <g id="Frame 471_3">
              <g id="diamond_4">
                <text
                  id="label_3"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={143.674} y={942.767}>
                    α-MSH
                  </tspan>
                </text>
                <path
                  id="Vector_8"
                  d="M165.371 961.102C165.783 960.992 166.217 960.992 166.629 961.102L193.754 968.37C195.561 968.854 197.215 967.201 196.73 965.394L189.462 938.269C189.352 937.857 189.352 937.423 189.462 937.011L196.73 909.885C197.215 908.078 195.561 906.425 193.754 906.909L166.629 914.177C166.217 914.288 165.783 914.288 165.371 914.177L138.246 906.909C136.439 906.425 134.785 908.078 135.27 909.885L142.538 937.011C142.648 937.423 142.648 937.857 142.538 938.269L135.27 965.394C134.785 967.201 136.439 968.854 138.246 968.37L165.371 961.102Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                  strokeMiterlimit={10}
                />
                <path
                  id="receptor-protein_3"
                  d="M194.488 972.352L166.665 965.213C166.12 965.073 165.548 965.073 165.003 965.213L138.512 972.011C137.034 972.39 136 973.722 136 975.249L136 990.399C136 992.583 138.059 994.18 140.174 993.637L165.101 987.241C165.646 987.102 166.217 987.102 166.762 987.241L192.826 993.929C194.941 994.472 197 992.874 197 990.691V975.59C197 974.064 195.966 972.732 194.488 972.352Z"
                  stroke="#1A1A1A"
                  strokeWidth={1.4}
                />
              </g>
            </g>
          </g>
          <path
            id="receptor-protein_4"
            d="M540.475 419.359L512.141 412.207C511.604 412.071 511.042 412.071 510.505 412.207L483.525 419.018C482.04 419.393 481 420.728 481 422.259L481 437.417C481 439.595 483.05 441.191 485.161 440.658L510.604 434.235C511.141 434.099 511.703 434.099 512.24 434.235L538.839 440.95C540.951 441.483 543 439.886 543 437.708V422.601C543 421.07 541.96 419.734 540.475 419.359Z"
            stroke="#1A1A1A"
          />
          <g id="lines_4">
            <path
              id="Vector_9"
              d="M512.742 318.7L512.742 318L511.342 318L511.342 318.7L512.042 318.7L512.742 318.7ZM512.042 408L516.083 401L508 401L512.042 408ZM512.042 318.7L511.342 318.7L511.342 401.7L512.042 401.7L512.742 401.7L512.742 318.7L512.042 318.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_10"
              d="M512.742 440.7L512.742 440L511.342 440L511.342 440.7L512.042 440.7L512.742 440.7ZM512.042 530L516.083 523L508 523L512.042 530ZM512.042 440.7L511.342 440.7L511.342 523.7L512.042 523.7L512.742 523.7L512.742 440.7L512.042 440.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_6">
            <text
              id="Line Label"
              transform="translate(133 1118) rotate(-90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={35.8594} y={16.086}>
                Activates
              </tspan>
            </text>
            <path
              id="Vector_11"
              d="M164.042 1118L168.083 1111L160 1111L164.042 1118ZM164.742 995.7L164.742 995L163.342 995L163.342 995.7L164.042 995.7L164.742 995.7ZM164.042 1111.7L164.742 1111.7L164.742 995.7L164.042 995.7L163.342 995.7L163.342 1111.7L164.042 1111.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_7">
            <path
              id="Vector_12"
              d="M163.042 1251L167.083 1244L159 1244L163.042 1251ZM163.742 1181.7L163.742 1181L162.342 1181L162.342 1181.7L163.042 1181.7L163.742 1181.7ZM163.042 1244.7L163.742 1244.7L163.742 1181.7L163.042 1181.7L162.342 1181.7L162.342 1244.7L163.042 1244.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_13"
              d="M330.042 1251L334.083 1244L326 1244L330.042 1251ZM330.742 1181.7L330.742 1181L329.342 1181L329.342 1181.7L330.042 1181.7L330.742 1181.7ZM330.042 1244.7L330.742 1244.7L330.742 1181.7L330.042 1181.7L329.342 1181.7L329.342 1244.7L330.042 1244.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_9">
            <path
              id="Vector_14"
              d="M281 1149.04L274 1145L274 1153.08L281 1149.04ZM219.7 1148.34L219 1148.34L219 1149.74L219.7 1149.74L219.7 1149.04L219.7 1148.34ZM274.7 1149.04L274.7 1148.34L219.7 1148.34L219.7 1149.04L219.7 1149.74L274.7 1149.74L274.7 1149.04Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_10">
            <text
              id="Line Label_2"
              transform="translate(133 908) rotate(-90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={43.998} y={16.086}>
                Makes
              </tspan>
            </text>
            <path
              id="Vector_15"
              d="M164.042 908L168.083 901L160 901L164.042 908ZM164.742 785.7L164.742 785L163.342 785L163.342 785.7L164.042 785.7L164.742 785.7ZM164.042 901.7L164.742 901.7L164.742 785.7L164.042 785.7L163.342 785.7L163.342 901.7L164.042 901.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_11">
            <text
              id="Line Label_3"
              transform="translate(135 730) rotate(-90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={40.9902} y={16.086}>
                Activate
              </tspan>
            </text>
            <path
              id="Vector_16"
              d="M166.042 730L170.083 723L162 723L166.042 730ZM166.742 602.7L166.742 602L165.342 602L165.342 602.7L166.042 602.7L166.742 602.7ZM166.042 723.7L166.742 723.7L166.742 602.7L166.042 602.7L165.342 602.7L165.342 723.7L166.042 723.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_12">
            <text
              id="Line Label_4"
              transform="translate(896.083 602) rotate(90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={40.9902} y={16.086}>
                Activate
              </tspan>
            </text>
            <path
              id="Vector_17"
              d="M865.742 602.7L865.742 602L864.342 602L864.342 602.7L865.042 602.7L865.742 602.7ZM865.041 730L869.083 723L861 723L865.041 730ZM865.042 602.7L864.342 602.7L864.341 723.7L865.041 723.7L865.741 723.7L865.742 602.7L865.042 602.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_13">
            <text
              id="Line Label_5"
              transform="translate(896.083 782) rotate(90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={200.408} y={16.086}>
                Signals to eat
              </tspan>
            </text>
            <path
              id="Vector_18"
              d="M865.742 782.7L865.742 782L864.342 782L864.342 782.7L865.042 782.7L865.742 782.7ZM865.041 1259L869.083 1252L861 1252L865.041 1259ZM865.042 782.7L864.342 782.7L864.341 1252.7L865.041 1252.7L865.741 1252.7L865.742 782.7L865.042 782.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_14">
            <text
              id="Line Label_6"
              transform="translate(167 574)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={82.7051} y={16.086}>
                High Leptin levels
              </tspan>
            </text>
            <path
              id="Vector_19"
              d="M167.7 601.7L427.3 601.7"
              stroke="#1A1A1A"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="lines_15">
            <text
              id="Line Label_7"
              transform="translate(309 617)"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={11.7051} y={16.086}>
                High Leptin levels
              </tspan>
            </text>
            <path
              id="Vector_20"
              d="M309.7 644.7H427.3"
              stroke="#E44C4B"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="lines_16">
            <text
              id="Line Label_8"
              transform="translate(597 619)"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={14.334} y={16.086}>
                Low Leptin levels
              </tspan>
            </text>
            <path
              id="Vector_21"
              d="M597.7 646.7H717.3"
              stroke="#E44C4B"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="lines_17">
            <g id="Frame 481_2">
              <path id="Vector_22" d="M725 716.3L709 716.3" stroke="#E44C4B" strokeWidth={1.4} />
              <path id="Vector_23" d="M717 715.6L717 647" stroke="#E44C4B" strokeWidth={1.4} />
            </g>
          </g>
          <g id="lines_18">
            <g id="Frame 481_3">
              <path id="Vector_24" d="M317 714.3L301 714.3" stroke="#E44C4B" strokeWidth={1.4} />
              <path id="Vector_25" d="M309 713.6L309 645" stroke="#E44C4B" strokeWidth={1.4} />
            </g>
          </g>
          <g id="lines_19">
            <text
              id="Line Label_9"
              transform="translate(595 574)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={88.834} y={16.086}>
                Low Leptin levels
              </tspan>
            </text>
            <path
              id="Vector_26"
              d="M595.7 601.7L864.3 601.7"
              stroke="#1A1A1A"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="Frame 466">
            <path
              d="M324.977 1266V1266.7H327C327.756 1266.7 328.493 1266.77 329.206 1266.92L329.341 1266.23C330.915 1266.54 332.378 1267.16 333.666 1268.02L333.278 1268.6C334.511 1269.43 335.572 1270.49 336.397 1271.72L336.978 1271.33C337.84 1272.62 338.459 1274.08 338.771 1275.66L338.085 1275.79C338.226 1276.51 338.3 1277.24 338.3 1278V1279.89H339V1283.67H338.3V1287.44H339V1291.22H338.3V1295H339V1298.78H338.3V1302.56H339V1306.33H338.3V1310.11H339V1313.89H338.3V1317.67H339V1321.44H338.3V1325.22H339V1329H338.3V1332.78H339V1336.56H338.3V1340.33H339V1344.11H338.3V1346C338.3 1346.76 338.226 1347.49 338.085 1348.21L338.771 1348.34C338.459 1349.92 337.84 1351.38 336.978 1352.67L336.397 1352.28C335.572 1353.51 334.511 1354.57 333.278 1355.4L333.666 1355.98C332.378 1356.84 330.915 1357.46 329.341 1357.77L329.206 1357.08C328.493 1357.23 327.756 1357.3 327 1357.3H324.977V1358H320.929V1357.3H316.881V1358H312.833V1357.3H308.786V1358H304.738V1357.3H300.69V1358H296.643V1357.3H292.596V1358H288.548V1357.3H284.5V1358H280.452V1357.3H276.404V1358H272.357V1357.3H268.31V1358H264.262V1357.3H260.214V1358H256.167V1357.3H252.119V1358H248.071V1357.3H244.023V1358H239.977V1357.3H235.929V1358H231.881V1357.3H227.833V1358H223.786V1357.3H219.738V1358H215.69V1357.3H211.643V1358H207.595V1357.3H203.548V1358H199.5V1357.3H195.452V1358H191.404V1357.3H187.357V1358H183.31V1357.3H179.262V1358H175.214V1357.3H171.167V1358H167.119V1357.3H163.071V1358H159.023V1357.3H157C156.244 1357.3 155.507 1357.23 154.794 1357.08L154.658 1357.77C153.084 1357.46 151.621 1356.84 150.333 1355.98L150.722 1355.4C149.489 1354.57 148.428 1353.51 147.603 1352.28L147.021 1352.67C146.16 1351.38 145.54 1349.92 145.229 1348.34L145.915 1348.21C145.809 1347.67 145.741 1347.12 145.714 1346.56L145.7 1346V1344.11H145V1340.33H145.7V1336.56H145V1332.78H145.7V1329H145V1325.22H145.7V1321.44H145V1317.67H145.7V1313.89H145V1310.11H145.7V1306.33H145V1302.56H145.7V1298.78H145V1295H145.7V1291.22H145V1287.44H145.7V1283.67H145V1279.89H145.7V1278C145.7 1277.24 145.774 1276.51 145.915 1275.79L145.229 1275.66C145.54 1274.08 146.16 1272.62 147.021 1271.33L147.603 1271.72C148.428 1270.49 149.489 1269.43 150.722 1268.6L150.333 1268.02C151.621 1267.16 153.084 1266.54 154.658 1266.23L154.794 1266.92C155.507 1266.77 156.244 1266.7 157 1266.7H159.023V1266H163.071V1266.7H167.119V1266H171.167V1266.7H175.214V1266H179.262V1266.7H183.31V1266H187.357V1266.7H191.404V1266H195.452V1266.7H199.5V1266H203.548V1266.7H207.596V1266H211.643V1266.7H215.69V1266H219.738V1266.7H223.786V1266H227.833V1266.7H231.881V1266H235.929V1266.7H239.977V1266H244.023V1266.7H248.071V1266H252.119V1266.7H256.167V1266H260.214V1266.7H264.262V1266H268.31V1266.7H272.357V1266H276.405V1266.7H280.452V1266H284.5V1266.7H288.548V1266H292.596V1266.7H296.643V1266H300.69V1266.7H304.738V1266H308.786V1266.7H312.833V1266H316.881V1266.7H320.929V1266H324.977Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block">
              <text
                id="H2 Header"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={208.804} y={1302.15}>
                  SATIETY
                </tspan>
              </text>
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={161.199} y={1334.77}>
                  (feeling full / stop eating)
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 468">
            <path
              d="M655.978 1207V1207.7H658C658.756 1207.7 659.493 1207.77 660.206 1207.92L660.341 1207.23C661.915 1207.54 663.378 1208.16 664.666 1209.02L664.278 1209.6C665.511 1210.43 666.572 1211.49 667.397 1212.72L667.978 1212.33C668.84 1213.62 669.459 1215.08 669.771 1216.66L669.085 1216.79C669.226 1217.51 669.3 1218.24 669.3 1219V1221H670V1225H669.3V1229H670V1233H669.3V1237H670V1241H669.3V1245H670V1249H669.3V1253H670V1257H669.3V1261H670V1265H669.3V1269H670V1273H669.3V1277H670V1281H669.3V1285H670V1289H669.3V1293H670V1297H669.3V1301H670V1305H669.3V1309H670V1313H669.3V1317H670V1321H669.3V1325H670V1329H669.3V1333H670V1337H669.3V1341H670V1345H669.3V1347C669.3 1347.76 669.226 1348.49 669.085 1349.21L669.771 1349.34C669.459 1350.92 668.84 1352.38 667.978 1353.67L667.397 1353.28C666.572 1354.51 665.511 1355.57 664.278 1356.4L664.666 1356.98C663.378 1357.84 661.915 1358.46 660.341 1358.77L660.206 1358.08C659.493 1358.23 658.756 1358.3 658 1358.3H655.978V1359H651.932V1358.3H647.887V1359H643.841V1358.3H639.796V1359H635.75V1358.3H631.704V1359H627.659V1358.3H623.613V1359H619.568V1358.3H615.522V1359H611.478V1358.3H607.432V1359H603.387V1358.3H599.341V1359H595.296V1358.3H591.25V1359H587.204V1358.3H583.159V1359H579.113V1358.3H575.068V1359H571.022V1358.3H566.978V1359H562.932V1358.3H558.887V1359H554.841V1358.3H550.796V1359H546.75V1358.3H542.704V1359H538.659V1358.3H534.613V1359H530.568V1358.3H526.522V1359H522.478V1358.3H518.432V1359H514.387V1358.3H510.341V1359H506.296V1358.3H502.25V1359H498.204V1358.3H494.159V1359H490.113V1358.3H486.068V1359H482.022V1358.3H477.978V1359H473.932V1358.3H469.887V1359H465.841V1358.3H461.795V1359H457.75V1358.3H453.704V1359H449.659V1358.3H445.613V1359H441.568V1358.3H437.522V1359H433.478V1358.3H429.432V1359H425.387V1358.3H421.341V1359H417.295V1358.3H413.25V1359H409.204V1358.3H405.159V1359H401.113V1358.3H397.068V1359H393.022V1358.3H391C390.244 1358.3 389.507 1358.23 388.794 1358.08L388.658 1358.77C387.084 1358.46 385.621 1357.84 384.333 1356.98L384.722 1356.4C383.489 1355.57 382.428 1354.51 381.603 1353.28L381.021 1353.67C380.16 1352.38 379.54 1350.92 379.229 1349.34L379.915 1349.21C379.809 1348.67 379.741 1348.12 379.714 1347.56L379.7 1347V1345H379V1341H379.7V1337H379V1333H379.7V1329H379V1325H379.7V1321H379V1317H379.7V1313H379V1309H379.7V1305H379V1301H379.7V1297H379V1293H379.7V1289H379V1285H379.7V1281H379V1277H379.7V1273H379V1269H379.7V1265H379V1261H379.7V1257H379V1253H379.7V1249H379V1245H379.7V1241H379V1237H379.7V1233H379V1229H379.7V1225H379V1221H379.7V1219C379.7 1218.24 379.774 1217.51 379.915 1216.79L379.229 1216.66C379.54 1215.08 380.16 1213.62 381.021 1212.33L381.603 1212.72C382.428 1211.49 383.489 1210.43 384.722 1209.6L384.333 1209.02C385.621 1208.16 387.084 1207.54 388.658 1207.23L388.794 1207.92C389.507 1207.77 390.244 1207.7 391 1207.7H393.022V1207H397.068V1207.7H401.113V1207H405.159V1207.7H409.204V1207H413.25V1207.7H417.296V1207H421.341V1207.7H425.387V1207H429.432V1207.7H433.478V1207H437.522V1207.7H441.568V1207H445.613V1207.7H449.659V1207H453.704V1207.7H457.75V1207H461.796V1207.7H465.841V1207H469.887V1207.7H473.932V1207H477.978V1207.7H482.022V1207H486.068V1207.7H490.113V1207H494.159V1207.7H498.204V1207H502.25V1207.7H506.296V1207H510.341V1207.7H514.387V1207H518.432V1207.7H522.478V1207H526.522V1207.7H530.568V1207H534.613V1207.7H538.659V1207H542.704V1207.7H546.75V1207H550.796V1207.7H554.841V1207H558.887V1207.7H562.932V1207H566.978V1207.7H571.022V1207H575.068V1207.7H579.113V1207H583.159V1207.7H587.205V1207H591.25V1207.7H595.296V1207H599.341V1207.7H603.387V1207H607.432V1207.7H611.478V1207H615.522V1207.7H619.568V1207H623.613V1207.7H627.659V1207H631.705V1207.7H635.75V1207H639.796V1207.7H643.841V1207H647.887V1207.7H651.932V1207H655.978Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_2">
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={440.726} y={1239.77}>
                  Modulates energy sensing{" "}
                </tspan>
                <tspan x={453.495} y={1263.77}>
                  Alters leptin sensitivity{" "}
                </tspan>
                <tspan x={423.957} y={1287.77}>
                  Increases reward-driven eating{" "}
                </tspan>
                <tspan x={407.065} y={1311.77}>
                  Shifts balance toward NPY signalling{" "}
                </tspan>
                <tspan x={395.349} y={1335.77}>
                  Weakens POMC/MC4R satiety response
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 467">
            <path
              d="M917.978 1267V1267.7H920C920.756 1267.7 921.493 1267.77 922.206 1267.92L922.341 1267.23C923.915 1267.54 925.378 1268.16 926.666 1269.02L926.278 1269.6C927.511 1270.43 928.572 1271.49 929.397 1272.72L929.978 1272.33C930.84 1273.62 931.459 1275.08 931.771 1276.66L931.085 1276.79C931.226 1277.51 931.3 1278.24 931.3 1279V1280.89H932V1284.67H931.3V1288.44H932V1292.22H931.3V1296H932V1299.78H931.3V1303.56H932V1307.33H931.3V1311.11H932V1314.89H931.3V1318.67H932V1322.44H931.3V1326.22H932V1330H931.3V1333.78H932V1337.56H931.3V1341.33H932V1345.11H931.3V1347C931.3 1347.76 931.226 1348.49 931.085 1349.21L931.771 1349.34C931.459 1350.92 930.84 1352.38 929.978 1353.67L929.397 1353.28C928.572 1354.51 927.511 1355.57 926.278 1356.4L926.666 1356.98C925.378 1357.84 923.915 1358.46 922.341 1358.77L922.206 1358.08C921.493 1358.23 920.756 1358.3 920 1358.3H917.978V1359H913.932V1358.3H909.887V1359H905.841V1358.3H901.796V1359H897.75V1358.3H893.704V1359H889.659V1358.3H885.613V1359H881.568V1358.3H877.522V1359H873.478V1358.3H869.432V1359H865.387V1358.3H861.341V1359H857.296V1358.3H853.25V1359H849.204V1358.3H845.159V1359H841.113V1358.3H837.068V1359H833.022V1358.3H828.978V1359H824.932V1358.3H820.887V1359H816.841V1358.3H812.796V1359H808.75V1358.3H804.704V1359H800.659V1358.3H796.613V1359H792.568V1358.3H788.522V1359H784.478V1358.3H780.432V1359H776.387V1358.3H772.341V1359H768.296V1358.3H764.25V1359H760.204V1358.3H756.159V1359H752.113V1358.3H748.068V1359H744.022V1358.3H742C741.244 1358.3 740.507 1358.23 739.794 1358.08L739.658 1358.77C738.084 1358.46 736.621 1357.84 735.333 1356.98L735.722 1356.4C734.489 1355.57 733.428 1354.51 732.603 1353.28L732.021 1353.67C731.16 1352.38 730.54 1350.92 730.229 1349.34L730.915 1349.21C730.809 1348.67 730.741 1348.12 730.714 1347.56L730.7 1347V1345.11H730V1341.33H730.7V1337.56H730V1333.78H730.7V1330H730V1326.22H730.7V1322.44H730V1318.67H730.7V1314.89H730V1311.11H730.7V1307.33H730V1303.56H730.7V1299.78H730V1296H730.7V1292.22H730V1288.44H730.7V1284.67H730V1280.89H730.7V1279C730.7 1278.24 730.774 1277.51 730.915 1276.79L730.229 1276.66C730.54 1275.08 731.16 1273.62 732.021 1272.33L732.603 1272.72C733.428 1271.49 734.489 1270.43 735.722 1269.6L735.333 1269.02C736.621 1268.16 738.084 1267.54 739.658 1267.23L739.794 1267.92C740.507 1267.77 741.244 1267.7 742 1267.7H744.022V1267H748.068V1267.7H752.113V1267H756.159V1267.7H760.204V1267H764.25V1267.7H768.296V1267H772.341V1267.7H776.387V1267H780.432V1267.7H784.478V1267H788.522V1267.7H792.568V1267H796.613V1267.7H800.659V1267H804.704V1267.7H808.75V1267H812.796V1267.7H816.841V1267H820.887V1267.7H824.932V1267H828.978V1267.7H833.022V1267H837.068V1267.7H841.113V1267H845.159V1267.7H849.204V1267H853.25V1267.7H857.296V1267H861.341V1267.7H865.387V1267H869.432V1267.7H873.478V1267H877.522V1267.7H881.568V1267H885.613V1267.7H889.659V1267H893.704V1267.7H897.75V1267H901.796V1267.7H905.841V1267H909.887V1267.7H913.932V1267H917.978Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_3">
              <text
                id="H2 Header_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={795.712} y={1303.15}>
                  HUNGER
                </tspan>
              </text>
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={746.228} y={1335.77}>
                  (feeling hungry / appetite)
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_20">
            <path
              id="Vector_27"
              d="M40.5 188.5L983.5 188.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469">
              <text
                id="Section Divider SubLabel"
                transform="translate(40 189)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={0} y={16.76}>
                  Adipose tissue
                </tspan>
              </text>
            </g>
          </g>
          <g id="lines_21">
            <path
              id="Vector_28"
              d="M40.5 355.5L983.5 355.5"
              stroke="#818181"
              strokeLinecap="round"
              strokeDasharray="8 8"
            />
            <g id="Frame 469_2">
              <text
                id="Section Divider SubLabel_2"
                transform="translate(40 356)"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={0} y={16.76}>
                  Neurons within the hypothalamus
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgCardiometabolicAppetiteControlDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1288}
    viewBox="0 142 1024 1288"
    fill="none"
    {...props}
  >
    <CardiometabolicAppetiteControlDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18293_231779">
        <rect width={1024} height={1430} fill="white" />
      </clipPath>
      <clipPath id="clip1_18293_231779">
        <rect width={1024} height={1288} fill="white" transform="translate(0 142)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCardiometabolicAppetiteControlDiagram;
